export class SortInfo {
    SortColumn: string = '';
    sortDirection: number | null = null;
}
